var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var Set = getNative(global, 'Set');

module.exports = Set;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_Set.js
 ** module id = 253
 ** module chunks = 0
 **/